// const DataCorrection = {
//     {
//         value: 1,
//         text: 'NAME'
//     },
//    {
//         value: 2,
//         text: 'NATIONALITY'
//     },
//     STATE: {
//         value: 3,
//         text: 'STATE'
//     },
//     LGA: {
//         value: 4,
//         text: 'LGA'
//     },
//     PHONE: {
//         value: 5,
//         text: 'PHONE'
//     },
//     OTHER: {
//         value: 6,
//         text: 'OTHER'
//     }
// }; 


const DataConstant = [
    {
        value: 1,
        text: 'NAME'
    },
   {
        value: 2,
        text: 'NATIONALITY'
    },

    {
        value: 3, 
        text: 'STATE',
    },

    {
        value: 4, 
        text: 'LGA'
    }, 

    {
        value: 5, 
        text: 'PHONE'
    }, 

     {
        value: 6, 
        text: 'OTHER'
    }
]; 

export default DataConstant;
